import React, { useMemo } from 'react'
import MealIngredientForm from './_form'

export default function MealIngredientAdd (props) {
  const data = useMemo(() => ({ active: false }), [])
  return (
    <MealIngredientForm data={data} {...props} />
  )
}